module.exports = __webpack_public_path__ + "img/v-king.08e635c4.png";